module.exports = __webpack_public_path__ + "static/media/DE_reading.688bc15c.mp4";